import { initDataList } from '../../../../../../core/types/coreTypes';
import { UnfinishedEntitiesReportData } from '../../../../../types/UnfinishedEntitiesReportTypes';

export const initUnfinishedEntitiesReportData: UnfinishedEntitiesReportData = {
  ...initDataList,
  maxSalesNet: 0,
  minSalesNet: 0,
};
